<template>

    <div class="header__right d-flex">
        <div class="o-userInfo d-flex">
            <!-- Cash + XP -->
            <div class="m-userInfo__data align-items-center d-none d-lg-flex">
                <div class="a-userInfo__item">
                    <span class="__coins"></span>{{ profil.pouzivatel_id.pouzivatel_wallet }}
                </div>
                <div class="a-userInfo__item">
                    <span class="__banknotes"></span>{{ profil.pouzivatel_id.pouzivatel_bankovky }}
                </div>
                <div class="a-userInfo__item">
                    <span class="__experience">
                        <span class="level-number">{{ profil.pouzivatel_id.level_id }}</span>
                    </span>{{ profil.pouzivatel_id.pouzivatel_xp }} / {{ profil.pouzivatel_id.pouzivatel_next_level_threshold }}
                </div>
            </div>

            <!-- Meno button -->
            <div v-if="typeof(show) != 'undefined'" :class="'m-userInfo__menu' + show">
                <button class="a-userInfo__name dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" :aria-expanded="aria" @click="dropdown()">
                    <span class="d-none d-md-inline-block">{{ profil.pouzivatel_id.pouzivatel_name }}</span>
                    <span class="d-inline-block d-md-none user__icon"></span>
                </button>

                <!-- Dropdown -->
                <div :class="'dropdown-menu' + show" aria-labelledby="dropdownMenuButton" x-placement="bottom-start">
                    <!-- Cash + XP phone -->
                    <div class="d-block d-lg-none userInfoMobile">
                        <div class="a-userInfo__item">
                            <span class="icon __coins"></span>{{ profil.pouzivatel_id.pouzivatel_wallet }}
                        </div>
                        <div class="a-userInfo__item">
                            <span class="icon __banknotes"></span>{{ profil.pouzivatel_id.pouzivatel_bankovky }}
                        </div>
                        <div class="a-userInfo__item">
                            <span class="icon __experience">
                                <span class="level-number">{{ profil.pouzivatel_id.level_id }}</span>
                            </span>{{ profil.pouzivatel_id.pouzivatel_xp }} / {{ profil.pouzivatel_id.pouzivatel_next_level_threshold }}
                        </div>
                    </div>

                    <!-- Dropdown menu -->
                    <router-link :to="{ name: 'profil' }" class="dropdown-item">
                        Môj profil
                    </router-link>
                    <router-link :to="{ name: 'kravicky' }" class="dropdown-item">
                        Moje kravičky
                    </router-link>
                    <a v-if="profil.pouzivatel_id.farma_pouzivatela.length != 0" 
                       :href="'https://www.adoptujkravicku.sk/hra/farma/moja-farma?' 
                       + profil.pouzivatel_id.id + '&' 
                       + profil.pouzivatel_id.pouzivatel_name + '&' 
                       + profil.pouzivatel_email" 
                       class="dropdown-item">
                        Moja farma
                    </a>
                    <router-link :to="{ name: 'aktivita' }" class="dropdown-item">
                        Moja aktivita
                    </router-link>
                    <router-link :to="{ name: 'album' }" class="dropdown-item">
                        Môj album
                    </router-link>
                    <router-link :to="{ name: 'statistiky' }" class="dropdown-item">
                        Štatistiky
                    </router-link>
                    <router-link :to="{ name: 'spravy' }" class="dropdown-item">
                        Správy
                    </router-link>
                    <router-link :to="{ name: 'heslo' }" class="dropdown-item">
                        Zmena hesla
                    </router-link>
                    <router-link :to="{ name: 'udaje' }" class="dropdown-item">
                        Moje údaje
                    </router-link>
                    <router-link :to="{ name: 'login', params: { reset: true } }" class="dropdown-item">
                        Odhlásiť sa
                    </router-link>
                </div>
                <!-- .Dropdown -->
            </div>
            <!-- .Meno button -->
        </div>

        <div class="header__right d-flex">

            <!-- Orange button -->
            <button :class="'hamburger hamburger--elastic' + isActive" type="button"  @click="sidemenu()">
            <span class="hamburger-box">
                <span class="hamburger-inner"></span>
            </span>
            </button>
            <!-- Sidemenu -->
            <menu-side
                :isActive="isActive"
            />

        </div>

    </div>
</template>



<script>
    import MenuSide from './MenuSide.vue'
    export default {
        components: {
            MenuSide
        },
        props: [
            'profil',
            'show'
        ],
        mounted() {
        },
        data() {
            return {
                isActive: '',
                aria: false
            }
        },
        methods: {
            toggleBodyClass(addRemoveClass, className) {
                const el = document.body
                if (addRemoveClass === 'addClass') {
                    el.classList.add(className)
                } else {
                    el.classList.remove(className)
                }
            },

            dropdown() {
                this.aria = !this.aria
                this.show == ' show' ?  this.show = '' : this.show = ' show'

                this.$emit('update:show', this.show)
                this.$emit('hideBottomControls')
            },

            sidemenu() {
                this.$emit('hideBottomControls')
                this.$emit('update:show', '')

                this.isActive == ' is-active' ?  this.isActive = '' : this.isActive = ' is-active'
                if (this.isActive == ' is-active') {
                    this.toggleBodyClass('addClass', 'menu-open')
                } else {
                    this.toggleBodyClass('removeClass', 'menu-open')
                }
            }
        }
    }
</script>